// src/components/CartSummary/CartSummary.js
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './CartSummary.css';
import { useNavigate } from 'react-router-dom';

const CartSummary = () => {
  const [cartItems, setCartItems] = useState([]);

  const navigate = useNavigate();

const handleNavigateToProduct = (id) => {
  navigate(`/product/${id}`);
};
  const handleRemove = (id) => {
    const updatedCart = cartItems.filter(item => item.id !== id);
    setCartItems(updatedCart);
    localStorage.setItem('cart', JSON.stringify(updatedCart));
  };

  useEffect(() => {
    const storedCart = localStorage.getItem('cart');
    if (storedCart) {
      const parsed = JSON.parse(storedCart);
      const cartWithQuantity = parsed.map(item => ({
        ...item,
        quantity: item.quantity || 1
      }));
      setCartItems(cartWithQuantity);
    }
  }, []);

  const updateQuantity = (id, delta) => {
    const updatedCart = cartItems.map(item => {
      if (item.id === id) {
        const newQuantity = item.quantity + delta;
        return {
          ...item,
          quantity: newQuantity > 1 ? newQuantity : 1
        };
      }
      return item;
    });
    setCartItems(updatedCart);
    localStorage.setItem('cart', JSON.stringify(updatedCart));
  };

  const totalPrice = cartItems.reduce((acc, item) => acc + item.price * item.quantity, 0);

if (cartItems.length === 0) {
  return (
    <div className="cart-summary-container">
      <h2>🛒 העגלה שלך ריקה</h2>
      <p style={{ textAlign: 'center', color: '#666', fontSize: '18px' }}>
        נראה שעוד לא הוספת מוצרים לעגלה... בוא נתחיל לקנות!
      </p>
<div className="empty-cart-button-wrapper">
  <Link to="/Products">
    <button className="empty-cart-shop-button">
      החנות לקיץ
    </button>
  </Link>
</div>
    </div>
  );
}

  return (
    <div className="cart-summary-container">
      <h2>🛒 עגלת קניות</h2>

      {cartItems.map((item, index) => (
        <div key={index} className="cart-item">
          <img src={item.image} alt={item.name} className="cart-item-image" />
          <div className="cart-item-details">
            <p
  className="cart-item-name"
  style={{ cursor: 'pointer'}}
  onClick={() => handleNavigateToProduct(item.id)}
>
  {item.name}
</p>

            <p className="cart-item-price">
              {(item.price * item.quantity).toFixed(2)} ₪
            </p>

            <div className="quantity-wrapper">
              <p className="quantity-label">כמות:</p>
              <div className="quantity-controls">
                <button onClick={() => updateQuantity(item.id, -1)} aria-label="הפחת כמות">-</button>
                <span>{item.quantity}</span>
                <button onClick={() => updateQuantity(item.id, 1)} aria-label="הוסף כמות">+</button>
              </div>
            </div>

            <button
              className="remove-from-cart-btn"
              onClick={() => handleRemove(item.id)}
            >
              הסר
            </button>
          </div>
        </div>
      ))}

      <div className="cart-total-summary">
        <p>סה"כ לתשלום: <strong>{totalPrice.toFixed(2)} ₪</strong></p>
        <p className='thepriceincloudmam'> המחיר כולל מע"מ</p>
      </div>
    </div>
  );
};

export default CartSummary;
